// withFunctions.jsx
import React from 'react';

// HOC to inject multiple functions as props
const withFunctions = (Component, functions) => {
    return (props) => {
        const injectedFunctions = functions?.current || functions || {};
        return <Component {...props} {...injectedFunctions} />;
    };
};

export default withFunctions;
